module.exports = __webpack_public_path__ + "static/pic02-1604b6dc0cea1438148330c5c90c72a6.jpg";